import AppLayout from '../../components/AppLayout';
import LoginRegisterBody from '../../components/LoginRegisterBody';
import ForgotPasswordForm from '../../components/ForgotPasswordForm';

export default function ForgotPasswordPage() {
  return (
    <AppLayout>
      <LoginRegisterBody>
        <ForgotPasswordForm />
      </LoginRegisterBody>
    </AppLayout>
  );
}
